export default {
  'app.pwa.offline': 'Вы сейчас не в сети',
  'app.pwa.serviceworker.updated': 'Доступен новый контент',
  'app.pwa.serviceworker.updated.hint':
    'Нажмите кнопку "Обновить", чтобы перезагрузить страницу',
  'app.pwa.serviceworker.updated.ok': 'Обновить',
  'app.updateCheck.title': 'Проверка обновлений',
  'app.updateCheck.backend': 'Бэкенд',
  'app.updateCheck.frontend': 'Фронтенд',
  'app.updateCheck.upToDate': 'Актуально',
  'app.updateCheck.newVersionAvailable':
    '{count} новое обновление{count, plural, one {} other {а}} доступно',
  'app.updateCheck.allUpToDate': 'Все компоненты актуальны',
  'app.updateCheck.viewRelease': 'Посмотреть релиз',
  'app.updateCheck.recheck': 'Проверить снова',
  'app.updateCheck.close': 'Закрыть',
  'app.updateCheck.failed': 'Не удалось проверить обновления, повторите позже',
};
